import React from 'react';
import PropTypes from 'prop-types';

import DetailedSwitch from '../DetailedSwitch';
import NumberSwitch from '../NumberSwitch';
import ProductSwitch from '../ProductSwitch';

import styles from './styles.module.css';

const RadioGroup = ({
    type, options, value, onSelect,
}) => {
    let elements = [];

    switch (type) {
    case 'box':
        elements = options.map((opt) => (
            <DetailedSwitch
                {...opt}
                onSelect={onSelect}
                checked={value === opt.value}
                key={`${type}${opt.value}`}
            />
        ));
        break;

    case 'number':
        elements = options.map((opt) => (
            <NumberSwitch
                value={opt}
                onSelect={onSelect}
                checked={value === opt}
                key={`${type}${opt}`}
            />
        ));
        break;

    case 'product':
        elements = options.map((opt) => (
            <ProductSwitch
                {...opt}
                onSelect={onSelect}
                checked={value === opt.asin}
                key={`${type}${opt.asin}`}
            />
        ));
        break;

    default:
        elements = [<span>No options provided.</span>];
    }

    return (
        <div className={styles.container}>
            {elements}
        </div>
    );
};

RadioGroup.propTypes = {
    type: PropTypes.oneOf(['box', 'number']).isRequired,
    options: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    ).isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onSelect: PropTypes.func.isRequired,
};

RadioGroup.defaultProps = {
    value: null,
};

export default RadioGroup;
